// The backend still answers some order routes with English developer text instead of an
// `error.<домэйн>.<нэр>` key (O16). Until de-order-service returns keys, the known messages are mapped
// here so the toast is translated by utils/message.ts (errors namespace).
const BACKEND_MESSAGE_KEYS: Record<string, string> = {
  "DeliveryNote created!": "error.delivery_note.already_created",
  "order notfound!": "error.order.backorder_not_available",
  "orders.length !== orderIds.length!": "error.delivery_note.orders_not_available",
}

/** Returns the i18n key for a known English backend message, the message itself otherwise. */
export function backendMessageKey(raw: string | undefined | null): string {
  if (!raw) return ""
  return BACKEND_MESSAGE_KEYS[raw] ?? raw
}
